<footer data-test="footer" class="custom-footer">
  <a data-test="contactLink" class="px-4 text-light" href="{{identityProviderUrl}}home/contact" target="_blank">
    {{ 'FOOTER.CONTACT' | translate}}
  </a>
  <a data-test="updatesLink" class="px-4 text-light" href="{{gprUserPortalBaseUrl}}/release-notes/gprmateriaal"
     target="_blank">
    Updates
  </a>
  <a data-test="aboutLink" class="px-4 text-light" href="https://www.w-e.nl/over-w-e-adviseurs/" target="_blank">
    {{ 'FOOTER.ABOUT_THE_CREATORS' | translate}}
  </a>
  <a data-test="privacyLink" class="px-4 text-light" href="{{identityProviderUrl}}home/privacy" target="_blank">
    {{ 'FOOTER.PRIVACY' | translate}}
  </a>
  <a data-test="termsLink" class="px-4 text-light"
     href="https://gprlogin.nl/documents/Algemene_voorwaarden_GPR_Software.pdf" target="_blank">
    {{ 'FOOTER.TERMS_AND_CONDITIONS' | translate}}
  </a>
</footer>